import { render, staticRenderFns } from "./Massmedia.vue?vue&type=template&id=63c23995"
import script from "./Massmedia.vue?vue&type=script&lang=js"
export * from "./Massmedia.vue?vue&type=script&lang=js"
import style0 from "./Massmedia.vue?vue&type=style&index=0&id=63c23995&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports